import React, { useEffect, useState } from 'react';
import { useHistory, withRouter } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Seccion from "../componentes/Seccion";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Parallax, Background } from 'react-parallax';
import Diamonds from '../componentes/common/Diamonds';


function Index() {
    const [isLoading, setisLoading] = useState(true);
    const history = useHistory();

    const irDicioUsuarios = () => {
        setTimeout(() => {
            history.push("/users");
        }, 300);    
    };

    const irDicioEmpresa = () => {
        setTimeout(() => {
            history.push("/company");
        }, 300);
    };

    useEffect(() => {
    var video= document.getElementById("videoDicio")
        if(video!== null){
            video.onended = () => {
                console.log("Termino video");
                setisLoading(false)
            }
        }
    }, [])

    return (

        <Parallax strength={500}>
            {
                (isLoading) ? 
                    <div className="dis-table w-100 full-section-video">
                        <div className="dis-table-section">
                            <div className="dis-table-cell-video">
                                <div className="dis-inline-block w-100">
                                    <video
                                    muted
                                    autoPlay
                                    id="videoDicio"
                                    className={"video"}>
                                    <source src="./video/video_intro.mp4" type="video/mp4"></source>
                                    </video>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <Seccion theme="dark" id="indexCont">  
                        <Row className="">
                            <div className="">
                                <Container className="" style={{padding:"0"}}>
                                    <Row className="header adelante">
                                        <Col sm={12} className="logo">
                                            <a href="#">
                                                <img src={"./img/logo_light.svg"} />
                                            </a>
                                        </Col>
                                    </Row>
                                        
                                    <Row className="btns adelante">
                                        <Col sm={12} md={12} lg={6} className="left-container" style={{paddingRight:"40px"}}>
                                            <button onClick={() => irDicioUsuarios()}> 
                                                <p className="fs-32">
                                                    <span className="fw-thin">DICIO FOR</span> <br/>
                                                    <span className="fw-bold">
                                                        <b>USERS</b>
                                                    </span>
                                                </p>

                                                <img src={"./img/users.svg"} alt=""/>
                                            </button>
                                        </Col>

                                        <Col sm={12} md={12} lg={6} className="right-container" style={{paddingLeft:"40px"}}>
                                            <button onClick={irDicioEmpresa}>
                                                <p className="fs-32">
                                                    <span className="fw-thin">DICIO FOR</span> <br/>
                                                    <span className="fw-bold">
                                                        <b>BUSINESS</b>
                                                    </span>
                                                </p>

                                                <img src={"./img/business.svg"} alt=""/>
                                            </button>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        </Row>
                        
                    </Seccion>
            }
        </Parallax>
          );
}

export default withRouter(Index)